import {TreeNode} from "primeng/api";
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Departments} from './departments';

@Injectable()
export class DepartmentsService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('departments?' + params.toString()).map((response: Response) => response.json());
    }
    getAllDepartments() {
        return this.http.get('departments/all').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('departments/' + _id).map((response: Response) => response.json());
    }

    getTree(_id:string) {
        return this.http.get('departments/tree/' + _id).toPromise().then(res => <TreeNode[]> res.json());
        // return this.http.get('departments/tree/' + _id).map((response: Response) => response.json());
    }

    getBranchDepartments(branch_id:string) {
        return this.http.get('branch/departments/' + branch_id).map((response: Response) => response.json());
    }

    checklast(_id: string) {
        return this.http.get('departments/checklast/' + _id).map((response: Response) => response.json());
    }

    getParents(_id: string, _branch_id: string,) {
        return this.http.get('departments/parents/' + _id + '/' + _branch_id).map((response: Response) => response.json());
    }

    getBranchDepartment(_id: string, _branch_id: string,) {
        return this.http.get('departments/branchdep/' + _id + '/' + _branch_id).map((response: Response) => response.json());
    }

    getDepartmentParent(_id: string, _branch_id: string,) {
        return this.http.get('departments/depparent/' + _id + '/' + _branch_id).map((response: Response) => response.json());
    }

    getTrashedById(_id: string) {
        return this.http.get('departments/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('departments/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(departments: Departments) {
        return this.http.post('departments', departments).map((response: Response) => response.json());
    }

    update(departments: Departments) {
        return this.http.put('departments/' + departments.id, departments).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('departments/' + _id).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/departments/departments.service.ts